// Split out from tokens.ts so client components can reference the cookie name
// without bundling the (server-only) jose/jwt verification code.
export const SESSION_COOKIE_NAME = "inner_circle_session";
